(() => {
  const root = window.Shopify?.routes?.root || '/';
  let giftBusy = false;

  function offerConfig() {
    const element = document.getElementById('SavressaOfferConfig');
    if (!element) return null;
    try {
      const config = JSON.parse(element.textContent);
      return {
        mainProductId: String(config.mainProductId).split('/').pop(),
        giftProductId: String(config.giftProductId).split('/').pop(),
        giftVariantId: Number(String(config.giftVariantId).split('/').pop()),
      };
    } catch {
      return null;
    }
  }

  function sectionTargets() {
    const targets = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
    const items = document.querySelector('cart-items');
    const footer = document.querySelector('#main-cart-footer');
    const itemsId = items?.dataset.id || items?.closest('.shopify-section')?.id.replace('shopify-section-', '');
    if (itemsId) targets.push({ id: itemsId, selector: '#shopify-section-' + itemsId });
    if (footer?.dataset.id) targets.push({ id: footer.dataset.id, selector: '#shopify-section-' + footer.dataset.id });
    return targets;
  }

  function renderSections(result, targets) {
    if (!result.sections) return;
    targets.forEach((target) => {
      const html = result.sections[target.id];
      if (!html) return;
      const current = document.querySelector(target.selector);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector(target.selector) || parsed.querySelector('.shopify-section');
      if (current && incoming) current.innerHTML = incoming.innerHTML;
    });
  }

  async function cart() {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }

  async function syncGift() {
    const config = offerConfig();
    if (!config || giftBusy) return;
    giftBusy = true;
    try {
      const currentCart = await cart();
      const cookware = currentCart.items.filter((item) => String(item.product_id) === config.mainProductId);
      const gifts = currentCart.items.filter((item) => String(item.product_id) === config.giftProductId);
      const targets = sectionTargets();
      const body = { sections: targets.map((target) => target.id), sections_url: window.location.pathname };
      let route = '';
      if (cookware.length && !gifts.length) {
        route = 'cart/add.js';
        body.items = [{ id: config.giftVariantId, quantity: 1 }];
      } else if (!cookware.length && gifts.length) {
        route = 'cart/update.js';
        body.updates = {};
        gifts.forEach((item) => { body.updates[item.key] = 0; });
      } else if (cookware.length && gifts.reduce((total, item) => total + item.quantity, 0) > 1) {
        route = 'cart/update.js';
        body.updates = {};
        gifts.forEach((item, index) => { body.updates[item.key] = index === 0 ? 1 : 0; });
      }
      if (!route) return;
      const response = await fetch(root + route, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error('Gift update failed');
      renderSections(result, targets);
      const latest = await cart();
      const drawer = document.querySelector('cart-drawer');
      drawer?.classList.toggle('is-empty', latest.item_count === 0);
      document.querySelector('cart-items')?.classList.toggle('is-empty', latest.item_count === 0);
      document.querySelector('#main-cart-footer')?.classList.toggle('is-empty', latest.item_count === 0);
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'savressa-gift', cartData: latest });
    } catch {
      document.querySelector('[data-vr-free-gift]')?.setAttribute('data-error', 'true');
    } finally {
      giftBusy = false;
    }
  }

  function initializeGift() {
    if (!window.savressaGiftInitialSync) {
      window.savressaGiftInitialSync = true;
      syncGift();
    }
    if (typeof subscribe !== 'function' || window.savressaGiftSubscribed) return;
    window.savressaGiftSubscribed = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'savressa-gift') syncGift();
    });
  }

  function initializeCountdowns() {
    const cookieValue = (key) => {
      const prefix = encodeURIComponent(key) + '=';
      const match = document.cookie.split('; ').find((entry) => entry.startsWith(prefix));
      return match ? Number(decodeURIComponent(match.slice(prefix.length))) : 0;
    };
    const storeEnd = (key, end, duration) => {
      document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(end)}; Max-Age=${Math.ceil(duration / 1000)}; Path=/; SameSite=Lax`;
    };
    document.querySelectorAll('[data-vr-countdown]').forEach((clock) => {
      if (clock.dataset.initialized) return;
      clock.dataset.initialized = 'true';
      const duration = (Number(clock.dataset.durationHours) || 24) * 60 * 60 * 1000;
      const key = clock.dataset.cookieKey || 'savressa_offer_end';
      let end = cookieValue(key);
      if (!Number.isFinite(end) || end <= Date.now()) {
        end = Date.now() + duration;
        storeEnd(key, end, duration);
      }
      const update = () => {
        let remaining = end - Date.now();
        if (remaining <= 0) {
          end = Date.now() + duration;
          storeEnd(key, end, duration);
          remaining = duration;
        }
        const values = {
          hours: Math.floor(remaining / 3600000),
          minutes: Math.floor(remaining / 60000) % 60,
          seconds: Math.floor(remaining / 1000) % 60,
        };
        Object.entries(values).forEach(([key, value]) => {
          const field = clock.querySelector(`[data-vr-${key}]`);
          if (field) field.textContent = String(value).padStart(2, '0');
        });
      };
      update();
      window.setInterval(update, 1000);
    });
  }

  function initializeGalleryControls() {
    document.querySelectorAll('[data-vr-gallery-step]').forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const gallery = button.closest('media-gallery');
        const thumbnails = [...gallery.querySelectorAll('.thumbnail')];
        const current = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true'));
        const next = (current + Number(button.dataset.vrGalleryStep) + thumbnails.length) % thumbnails.length;
        thumbnails[next]?.click();
      });
    });
  }

  function initializeSticky() {
    const bar = document.querySelector('.vr-sticky-buy');
    const product = document.querySelector('.vr-pdp');
    if (!bar || !product || bar.dataset.initialized) return;
    const primary = product.querySelector('button[name="add"]');
    const button = bar.querySelector('button');
    if (!primary || !button) return;
    bar.dataset.initialized = 'true';
    const sync = () => {
      button.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
      button.textContent = primary.disabled ? 'Sold out' : primary.getBoundingClientRect().top > window.innerHeight ? 'Choose color' : primary.querySelector('span').textContent.trim();
      const price = product.querySelector('.vr-offer-price')?.textContent || '';
      const color = product.querySelector('[data-selected-value]')?.textContent || '';
      const label = bar.querySelector('[data-vr-sticky-price]');
      if (label) label.textContent = price + ' · ' + color;
    };
    button.addEventListener('click', () => {
      if (button.disabled) return;
      if (primary.getBoundingClientRect().top > window.innerHeight) product.querySelector('variant-selects')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else primary.click();
    });
    new MutationObserver(sync).observe(product, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    new IntersectionObserver(([entry]) => {
      bar.hidden = entry.isIntersecting || (entry.boundingClientRect.top > 0 && window.innerWidth >= 750);
      button.textContent = primary.disabled ? 'Sold out' : entry.boundingClientRect.top > 0 ? 'Choose color' : primary.querySelector('span').textContent.trim();
    }, { threshold: 0 }).observe(primary);
    sync();
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.vr-mobile-menu[open]');
    if (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', (event) => {
    const menu = document.querySelector('.vr-mobile-menu[open]');
    if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  });

  function initialize() {
    initializeGift();
    initializeCountdowns();
    initializeGalleryControls();
    initializeSticky();
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
